<template>
  <svg :width="width" :height="height" :viewBox="viewBox"
       @click="$emit('click')"
       @mouseover="hover = true"
       @mouseleave="hover= false"
       xmlns="http://www.w3.org/2000/svg">
    <g>
      <path :fill="backgroundFillColor" d="M2 11h26v8H2z"/>
      <path :fill="strokeColor" d="M15 0C6.71579102 0 0 6.71579102 0 15c0 8.284209 6.71579102 14.9994474 15 14.9994474 8.284209 0 15-6.7152384 15-14.9994474 0-8.28420898-6.715791-15-15-15M9.4138236 18.3031833c-.1248987 0-.24206028-.0502911-.33214207-.1436888L6.5262324 15.6073613l-2.5653968 2.5615282c-.08621324.0862133-.20116424.1337411-.32385233.1337411-.2525606 0-.4586987-.2050328-.4586987-.458146 0-.1243461.04918577-.2404024.13926756-.3288262l2.55821237-2.5626336-2.55931766-2.5593176c-.08842385-.0873186-.13816226-.2028222-.13816226-.326063 0-.2531132.2061381-.4586987.4586987-.4586987.12213543 0 .23708643.0475279.32385233.1331885l2.56926536 2.5598703s2.55710707-2.5560018 2.55765972-2.5565544c.0867659-.0878712.20226954-.1365044.32606292-.1365044.25311325 0 .4586987.2055855.4586987.4586987 0 .1215828-.04752783.2359812-.13208313.3227471l-2.5598703 2.5659494 2.55821235 2.5648442c.08621325.0862132.13374107.2011642.13374107.3232997 0 .2531132-.2061381.4586987-.4586987.4586987m6.1565102-2.9804363s-4.5118267.0005527-4.7875986.0005527c.0011053.0221059.0033159.0458699.0060792.0707391.0243165.1326357.0580281.261403.1027927.385749.2536659.6642841.9676885 1.5954977 2.3017832 1.6104193.407855-.0022106.7908408-.1050034 1.127404-.2846143.2647189-.1475573.4852259-.3382212.6631789-.5344116.0585808-.0707391.1121877-.1409255.1602682-.209454.2238229-.2868248.5084371-.2337705.6775477-.1044507.2006116.1541891.2348758.4763835.051949.7029696-.0055265.0060792-.0105003.0116056-.0160268.0176848-.2630609.3299315-.5349643.6057033-.8604745.8151573-.313352.2006116-.6532312.3431951-1.0052686.4288557-.4089603.1061086-.8041044.1293198-1.2097488.0801341-1.3678063-.1674527-2.5151057-1.1776951-2.8544322-2.5117899-.06797585-.2685874-.10058214-.5410434-.10058214-.8112888 0-1.0771129.51893743-2.1227249 1.41754473-2.7621398 1.1008769-.7831037 2.6068455-.8228944 3.7475131-.0989242.7797878.4935156 1.2920934 1.2622504 1.4899418 2.1978852.0972662.5299904-.2558765.9931103-.9118709 1.0069265m3.8613588-2.755508c-.9947683.124346-1.1008769.593545-1.1008769 1.754108v3.4833468c-.0005526.2525606-.2061381.4575934-.4586987.4575934-.2520079 0-.4575934-.2050328-.4586987-.4570407 0 0-.0011053-5.6640999-.0011053-5.6646526.0005527-.2525606.2022696-.4548301.4542775-.4548301.2194017 0 .4034338.1547417.4481984.3608798.3415371-.263061.7499447-.396802 1.1732739-.396802l.1409255.0005526c.2536659 0 .4603566.2055855.4603566.4586987 0 .2525606-.1934271.439356-.4653305.448751-.0005526 0-.1005821-.0016579-.1923218.0093951m3.7994621 5.7514184c-1.8541375 0-3.3628694-1.5081792-3.3628694-3.3628693 0-1.8541375 1.5087319-3.3628694 3.3628694-3.3628694 1.8546901 0 3.3639746 1.5087319 3.3639746 3.3628694 0 1.8546901-1.5092845 3.3628693-3.3639746 3.3628693zm-10.052078-5.7863459c-1.1351411 0-2.0884607.7786825-2.3548375 1.8314789-.0005527.0132636-.001658.0259745-.001658.0386855h4.7201754c-.2525606-1.0721392-1.2141699-1.8701644-2.3636799-1.8701644zm10.052078.0101135c-1.3307789 0-2.4134184 1.0826395-2.4134184 2.4134183 0 1.3307789 1.0826395 2.4134184 2.4134184 2.4134184 1.3307788 0 2.4134183-1.0826395 2.4134183-2.4134184 0-1.3307788-1.0826395-2.4134183-2.4134183-2.4134183zm.0011053 3.2468131c-.4603567 0-.8339474-.3741434-.8339474-.8333948 0-.459804.3735907-.8333947.8339474-.8333947.4592513 0 .8328421.3735907.8328421.8333947 0 .4592514-.3735908.8333948-.8328421.8333948z"/>
    </g>
  </svg>
</template>
<script>
const WHITE = "#FFF";
const BLUE = "#13B5EA";

export default {
  name: 'XeroIcon',
  props: {
    width: {
      default: 30,
      required: false,
    },
    height: {
      default: 30,
      required: false,
    },
    altOnHover: {
      type: Boolean,
      default: false,
      required: false,
    }
  },
  computed: {
    viewBox() {
      return `0 0 ${this.width} ${this.height}`;
    },
    backgroundFillColor() {
      if (this.altOnHover) {
        return this.hover ? WHITE : BLUE;
      }

      return BLUE;
    },
    strokeColor() {
      if (this.altOnHover) {
        return this.hover ? BLUE : WHITE;
      }

      return WHITE;
    },
  },
  data() {
    return {
      hover: false,
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/xero/XeroIcon.vue